import { cn } from '@listening/utils/react-helpers';
import type * as React from 'react';

type TextareaProps = React.ComponentProps<'textarea'>;

const Textarea = ({ ref, className, ...props }: TextareaProps) => (
  <textarea
    className={cn(
      'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    ref={ref}
    {...props}
  />
);
Textarea.displayName = 'Textarea';

export { Textarea };
